import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiLoginService } from '../../api/api-login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import conf from '../../_models/conf.json';

import { AuthenticationService } from '../../_services/authentication.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  private c = conf;

  constructor(
    private router: Router,
    private loadjs: LoadJsService,
    private api: ApiLoginService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) { }

  loginForm: FormGroup;
  title = this.c.web.name;
  version = this.c.web.version;
  loadinglogin = false;
  returnUrl: string;
  errorMessage = 'Username / Password salah, silahkan cek kembali';
  error = false;
  alert_failed = false;
  modalerror = true;

  private loadScriptsLogin() {
    this.loadjs.loadScriptLoginJs()
  }

  ngOnInit() {
    this.loadScriptsLogin();
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    }, {

    });

    //  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    //  console.log(this.returnUrl);
    this.ceklogin();
  }

  get f() { return this.loginForm.controls; }

  login() {
    let data = {
      'username': this.f.username.value,
      'password': this.f.password.value,
    };
    this.loadinglogin = true;

    this.authenticationService.login(data)
      .pipe(first())
      .subscribe(
        response => {
          // console.log(this.returnUrl);
          if (response.status) {
            if (this.returnUrl) {
              // console.log("retur", this.returnUrl)
              this.router.navigate([this.returnUrl]);
            } else {
              // console.log("naviget")
              this.router.navigate(['/dashboard']);
            }
          } else {
            this.error = true;
            this.errorMessage = response.message;
          }
          this.loadinglogin = false;
          // console.log("gagal")
          // this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(() => {
            this.alert_failed = false
          }, 6000);
          setTimeout(() => {
            this.modalerror = false
          }, 6000);
        },
        error => {
          this.error = true;
          this.loadinglogin = false;
          console.log(error);
          setTimeout(() => {
            this.error = false
          }, 6000);
        });

    // (output: any) => {
    //   console.log(output)
    //   if ( output.status ){
    //     console.log("masuk")

    //         this.router.navigate(['/dashboard']);

    //   } else {
    //     this.LoadJsOrder.loadScriptProductStb()
    //     this.alert_failed = true
    //     setTimeout(()=>{
    //       this.alert_failed = false
    //     }, 6000);
    //   }
    // })

  }

  ceklogin() {

    const currentUser: any = this.api.currentUserValue;
    // console.log(currentUser);
    if (currentUser != null) {

      if (currentUser.status != false) {
        // authorised so return true
        this.router.navigate(['']);
      }

    }
  }

}
